<template>
    <v-container fluid>
        <v-layout class="devices-list pa-0 mt-4" v-if="wiredList.length > 0" row>
            <v-flex
                class="devices-list__device"
                :class="{'devices-list__device__large': largeScreen}"
                :xs4="!largeScreen"
                :xs3="largeScreen"
                v-for="(wiredColumn, indexColumn) in wiredList"
                :key="`wiredColumn${indexColumn}`"
            >
                <v-layout column>
                    <v-flex v-for="(wired, index) in wiredColumn" :key="`wired${index}`">
                        <ZigbeeDevice
                            :device="wired"
                            :controller="controllerId"
                            :first="indexColumn == 0"
                            :last="indexColumn == wiredList.length - 1"
                            :update="addDevice"
                        />
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ZigbeeDevice from "@/components/ZigbeeDevice";

export default {
    name: "DebugControllerDevices",
    components: {ZigbeeDevice},
    props: {
        controllerId: {
            type: String,
            required: true,
        },
        controllerFullData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            controllerData: {},
            windowWidth: window.innerWidth,
            newDevices: [],
        };
    },
    mounted() {
        this.controllerData = JSON.parse(JSON.stringify(this.controllerFullData));
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    computed: {
        largeScreen() {
            return this.windowWidth > 1440;
        },
        wiredList() {
            if (this.controllerData) {
                let wiredDevices = this.controllerData.wired_devices ? JSON.parse(JSON.stringify(this.controllerData.wired_devices)) : [];
                let divider = this.largeScreen ? 4 : this.windowWidth > 1151 ? 3 : this.windowWidth > 701 ? 2 : 1;
                let minLength = parseInt(wiredDevices.length / divider);
                let wiredArr = [];
                let slice = 0;
                for (let i = 0; i < divider; i++) {
                    if ((wiredDevices.length % divider) > i) {
                        wiredArr[i] = wiredDevices.slice(slice, slice + minLength + 1);
                        slice += minLength + 1;
                    } else {
                        wiredArr[i] = wiredDevices.slice(slice, slice + minLength);
                        slice += minLength;
                    }
                }
                return wiredArr;
            }
            return [];
        },
    },
    methods: {
        addDevice(data) {
            let is_new = false;
            if (data.device.is_new) {
                is_new = true;
            }
            if (this.controllerData.wired_devices) {
                let index = this.controllerData.wired_devices.map(wired => {
                    return wired.inner_number
                }).indexOf(data.device.inner_number);
                if (index != -1) {
                    this.$set(this.controllerData.wired_devices, index, data.device);
                    is_new = false;
                } else if (this.newDevices) {
                    let index = this.newDevices.map(wired => {
                        return wired.inner_number
                    }).indexOf(data.device.inner_number);
                    if (index != -1) {
                        this.$set(this.newDevices, index, data.device);
                        is_new = false;
                    }
                }
            }
            if (is_new) {
                this.newDevices.unshift(data.device);
            }
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        back() {
            if (this.controllerData && this.controllerData.hotel_room) {
                this.$router.push({name: "roompage", params: {id: this.controllerData.hotel_room.uid}});
            }
        },
    },
}
</script>

<style scoped>

</style>